export * from "./EventsLocator";
export type { EventsLocatorProps } from "./types";
